var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"loadMoreTrigger",staticClass:"table-load-placeholder"},[(_vm.more)?_c('div',{staticClass:"loading-spinner"},[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"3"}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }